module.exports = __webpack_public_path__ + "static/img/gpt16.b7c1e111.png";